module.exports = __webpack_public_path__ + "static/FESTIVAL_FIERTE_MTL-886af5f57038c357b1c55d594b5a9d5c.png";